import React, { useEffect, useState } from "react";
import {useVsiAppContext} from "../../../stores/VsiApp";
import Grid from "../../../components/Grid";
import {VsiBubble, VsiH4} from "../../../styled/App.styled";
import {useDataWithRoute, useTitleFromComponent} from "../../../utils/hooks";
import {Card, Spinner} from "reactstrap";
import { hostLunListDefs } from "../../../utils/gridColumnDefs/hosts/hostsLunList";

export default function HostLunList({context, title}) {
    useTitleFromComponent(`${context} / ${title}`);
    const [gridData, setGridData] = useState([]);

    const { theme, client, periodId } = useVsiAppContext();

    const [data, {isLoading}] = useDataWithRoute(`/api/v6/report/enterprise_host_lun_list_proc?client_id=${client.clientId}&period_id=${periodId}`);

    useEffect(() => {
        if(!isLoading) {
            setGridData(data?.recordset || [])
        }
    }, [data]);

    return <Card className={`report-card p-2 nav-card-${theme}`}>
        <VsiH4>Host LUNs</VsiH4>
        {isLoading ? <Spinner color={"primary"}/> : (
            <VsiBubble>
                <Grid data={gridData} columnDefs={hostLunListDefs} isLoading={isLoading}/>
            </VsiBubble>
        )}
    </Card>
}
